module.exports = __webpack_public_path__ + "static/media/22ESCWA11.3fc6e9f8.jpg";